import { useCallback } from 'react'
import { Modal, message } from '@surecompanies/core_components'

import { useUnreturnTransaction } from '../../api/reconciliation-v2-api-client'
import { extractApiErrorMessage } from './AdjustPaymentModal.helpers'

export interface UnreturnTarget {
  transactionId: string
  /** Human-facing number for the confirm copy; falls back to the id. */
  transactionNumber?: string | null
}

/**
 * Returns a handler that opens a confirm and un-returns the transaction. The tx
 * goes back to the Unallocated-payments queue and may be auto-allocated again.
 */
export const useConfirmUnreturnTransaction = (): ((
  target: UnreturnTarget
) => void) => {
  const unreturnTransaction = useUnreturnTransaction({
    onError: (err: unknown) => {
      message.error(`Failed to undo the return: ${extractApiErrorMessage(err)}`)
    },
  })
  return useCallback(
    (target: UnreturnTarget) => {
      Modal.confirm({
        title: 'Un-return transaction?',
        content: `Transaction ${target.transactionNumber ?? target.transactionId} will move back to Unallocated payments and may be auto-allocated again.`,
        okText: 'Un-return',
        onOk: async () => {
          try {
            await unreturnTransaction.mutateAsync({
              transactionId: target.transactionId,
            })
            message.success('Return undone')
          } catch {
            /* onError shows the toast */
          }
        },
      })
    },
    [unreturnTransaction]
  )
}
